/* global Lime */
import store from "@/store";
const config = {
    host:process.env.VUE_APP_API_URL,
    appid:'20250401152132743897',
    secret:'02fbd17d822cac153e8b0ccec014d6be',
    ver:'1.0.0',
    selftoken:'syyj',
    debug:process.env.NODE_ENV == 'production'  ? false : true
}

// eslint-disable-next-line no-undef
const lime = new Lime(config);
if (store.state.InitData.token_num == 0) {
    lime.set_token();
    store.commit('setTokenNum', 1);
}

if (lime.get_token() == null) {
    lime.set_token();
}
export default lime;